
import { ArtistModel } from '@/typings';
import { defineComponent, PropType } from 'vue';

import { RouterLink } from 'vue-router';
import { StyleTag } from '@/components/common';

export default defineComponent({
    components: {
        RouterLink,
        StyleTag
    },
    props: {
        artist: {
            type: Object as PropType<ArtistModel>,
            required: true
        },
        showStyles: {
            type: Boolean,
            default: false
        }
    }
});

